const initLightboxLinker = () => {
  const galleryShowcase = document.getElementById('gallery-showcase');
  if (!galleryShowcase) {
    return;
  }

  const lightboxModal = document.getElementById('pictures-lightbox');
  if (!lightboxModal) {
    return;
  }

  const lightboxSwiperDiv = lightboxModal.querySelector('.pictures-lightbox__swiper');
  if (!lightboxSwiperDiv) {
    return;
  }

  // Use event delegation on the gallery drawer
  galleryShowcase.addEventListener('click', function(event) {
    // Find the closest .img-showcase element that was clicked
    const clickedItem = event.target.closest('.img-showcase');
    if (clickedItem && clickedItem.hasAttribute('data-slide-index')) {
      const slideIndex = parseInt(clickedItem.dataset.slideIndex, 10);

      if (lightboxSwiperDiv.swiper) {
        lightboxSwiperDiv.swiper.slideToLoop(slideIndex, 0);
      }
    }
  });
};

export { initLightboxLinker };
